import React, {
  useState,
  useEffect,
  useRef,
  useCallback,
  useMemo,
  useLayoutEffect,
} from "react";
import "../index.css";
import { merge } from "lodash";

const today = new Date();

function formatServerDate(date) {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
}

const defaultConfig = {
  server: { date: formatServerDate(today) },
  icons: {
    leftArrow: "/chevron-left.svg",
    rightArrow: "/chevron-right.svg",
    iconContainerCss: {
      width: "32px",
      height: "32px",
      border: "none",
      outLine: "none",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      // borderRadius:"50%",
      // color:"#362525",
      backgroundColor: "transparent",
      boxShadow: "0 2px 4px rgba(0,0,0,0.2)",
      transition: "background-color 0.3s, color 0.3s",
      cursor: "pointer",
      // margin:"0 5px",
      // padding:"0",
    },
  },
  popup: {
    popupHasBgImage: false,
    popupBgImage: "",
    popupBgColor: "#fff",
    popupTextColor: "#362525",
    popupHasFooterText: true,
    popupBorder: "1px solid #362525",
    popupBoxShadow: "rgba(0, 0, 0, 0.24) 0px 3px 8px",
    currency: "INR",
    currencySymbol: "₹",
    dateTitle: "Departue Date",

    currentDateBgColor: "transparent",
    currentDateTextColor: "#0B70F2",
    currentDateRadius: "4px",
    currentDateMargin: "2px",
    currentDatePadding: "2px",
    currentDateBorder: "1px solid #0B70F2",

    selectDateBgColor: "#0B70F2",
    selectDateTextColor: "#fff",
    selectDateRadius: "4px",
    selectDateMargin: "2px",
    selectDatePadding: "2px",
    selectDateBorder: "",

    popupFooterText: [
      { month: 8, footerText: "Welcome to V" },
      { month: 9, footerText: "Enjoy October!" },
    ],
    popupCustomCss: {},
  },
  calendar: {
    monthView: "single",
    calendarStartDate: "01/01/2025",
    calendarEndDate: "31/11/2025",
    weeks: {
      weekColor: "#0c0c0c",
      weelBgColor: "",
      weekCustomCss: {},
    },
    dayNotes: [
      // { noteDate: "12/09/2025", noteText: "1200" },
      // { noteDate: "14/09/2025", noteText: "1100" },
      // { noteDate: "15/09/2025", noteText: "900" },
      // { noteDate: "18/09/2025", noteText: "850" },
      // { noteDate: "10/09/2025", noteText: "1050" },
      // { noteDate: "6/09/2025", noteText: "1150" },
      // { noteDate: "02/10/2025", noteText: "800" },
    ],
    dayBgImages: [
      {
        date: "15/08/2025",
        bgImage:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/3/3a/Animated-Flag-India.gif/275px-Animated-Flag-India.gif",
        textColor: "#fff",
      }
      // {
      //   date: "22/09/2025",
      //   bgImage: "https://gta.etechnology.co/kittur/images/navratri1.jpg",
      //   textColor: "#fff",
      // },
      // {
        
      //   date: "23/09/2025",
      //   bgImage: "https://gta.etechnology.co/kittur/images/navratri2.jpg",
      //   textColor: "#fff",
      // },
      // {
      //   date: "24/09/2025",
      //   bgImage: "https://gta.etechnology.co/kittur/images/navratri3.jpg",
      //   textColor: "#fff",
      // },
      // {
      //   date: "25/09/2025",
      //   bgImage: "https://gta.etechnology.co/kittur/images/navratri4.jpg",
      //   textColor: "#fff",
      // },
      // {
      //   date: "26/09/2025",
      //   bgImage: "https://gta.etechnology.co/kittur/images/navratri5.jpg",
      //   textColor: "#fff",
      // },
      // {
      //   date: "27/09/2025",
      //   bgImage: "https://gta.etechnology.co/kittur/images/navratri6.jpg",
      //   textColor: "#fff",
      // },
      // {
      //   date: "28/09/2025",
      //   bgImage: "https://gta.etechnology.co/kittur/images/navratri7.jpg",
      //   textColor: "#fff",
      // },
      // {
      //   date: "29/09/2025",
      //   bgImage: "https://gta.etechnology.co/kittur/images/navratri8.jpg",
      //   textColor: "#fff",
      // },
      // {
      //   date: "30/09/2025",
      //   bgImage: "https://gta.etechnology.co/kittur/images/navratri9.jpg",
      //   textColor: "#fff",
      // },
    ],
    dayBgStyles: {
      borderRadius: "0px ",
      backgroundSize: "100%",
      backgroundPosition: "center",
      margin: "0",
      padding: "0",
      fontWeight: "500",
      fontSize: "12px",
    },
    dayImages:[{
      date: "02/10/2025",
      image:"https://gta.etechnology.co/kittur/images/gj.png"
    }],

    monthBgImages: [
      // { month:8, bgImage:"https://images.unsplash.com/photo-1506744038136-46273834b3fb?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" },
      // { month:9, bgImage:"https://images.unsplash.com/photo-1504384308090-c894fdcc538d?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80"    },
      // { month:10, bgImage:"https://images.unsplash.com/photo-1500534623283-312aade485b7?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=1170&q=80" }
    ],
    disabledDatesList: [
      {
        date: "19/09/2025",
        reason: "Day Locked",
      },
      {
        date: "20/09/2025",
        reason: "Day Locked",
      },
    ],

    holidays: [
      {
        holidayDate: "29/09/2025",
        holidayText: "Festival",
        holidayType: "public",
        holidayBgColor: "#ffe0e0",
        holidayTextColor: "#d00000",
        holidayCellRadius: "30%",
        holidayPadding: "2px",
      },
    ],
    weekends: {
      sundaysColor: "#F9E480",
      saturdaysColor: "#F9E480",
      sundayTextColor: "#362525",
      saturdayTextColor: "#362525",
    },
    tooltips:[
      { date: "15/08/2025", tooltipText: "Independence Day" },
      { date: "22/09/2025", tooltipText: "Day 1 Navratri parva" },
      { date: "23/09/2025", tooltipText: "Day 2 Navratri parva" },
      { date: "24/09/2025", tooltipText: "Day 3 Navratri parva" },
      { date: "25/09/2025", tooltipText: "Day 4 Navratri parva" },
      { date: "26/09/2025", tooltipText: "Day 5 Navratri parva" },
      { date: "27/09/2025", tooltipText: "Day 6 Navratri parva" },
      { date: "28/09/2025", tooltipText: "Day 7 Navratri parva" },
      { date: "29/09/2025", tooltipText: "Day 8 Navratri parva" },
      { date: "30/09/2025", tooltipText: "Day 9 Navratri parva" },
      { date: "02/10/2025", tooltipText: "Oct 2 Gandhi Jayanti" },
    ],

    cellCustomCss: {},
  },
};

const parseDate = (dateStr) => {
  const [day, month, year] = dateStr.split("/");
  return new Date(year, month - 1, day);
};

const formatDate = (date) => {
  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const year = date.getFullYear();
  return `${day}/${month}/${year}`;
};

const VDatePicker4b = ({
  configFromApi = null,
  targetRef,
  onDateSelect,
  styleCallback,
  minDate = null,
  openOnClose = false,
  currentDateFromParent = null,
  
}) => {
  const [config, setConfig] = useState(defaultConfig);
  const [selectedDate, setSelectedDate] = useState(
    parseDate(defaultConfig.server.date)
  );
  const [currentDate, setCurrentDate] = useState(
    parseDate(defaultConfig.server.date)
  );
  const [isOpen, setIsOpen] = useState(openOnClose);
  const popupRef = useRef(null);
  const inputRef = useRef(null);
  const [calendarStartDate, setCalendarStartDate] = useState(
    config.calendar.calendarStartDate ? config.calendar.calendarStartDate : null
  );
  const [calendarEndDate, setCalendarEndDate] = useState(
    config.calendar.calendarEndDate ? config.calendar.calendarEndDate : null
  );

  // popup style info (keeps numeric px values, not CSS strings)
  const [popupPos, setPopupPos] = useState({
    top: 0,
    left: 0,
    right: null,
    bottom: null,
    maxHeight: null,
    visibility: "hidden",
    placement: "bottom",
    maxWidth: null,
  });

  const months = useMemo(
    () => [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    []
  );

  const weekdays = useMemo(
    () => ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
    []
  );

  // Toggle popup on target click

  useEffect(() => {
    const handleClick = (event) => { event.preventDefault(); setIsOpen((prev) => !prev);};
    const target = targetRef?.current;
    if (target) {
      inputRef.current = target;
      target.addEventListener("click", handleClick);
      return () => target.removeEventListener("click", handleClick);
    }
  }, [targetRef]);

  useEffect(() => {
    if (configFromApi) {
      const mergedConfig = merge({}, defaultConfig, configFromApi);
      // console.log("merged config");
      // console.log(mergedConfig);
       setConfig(mergedConfig);
       //console.log(mergedConfig);
    }
  }, [configFromApi]);


  useEffect(() => {
    if(currentDateFromParent !=null){
     // console.log("currentDateFromParent changed:", currentDateFromParent);
      setSelectedDate(parseDate(currentDateFromParent));
      setCurrentDate(parseDate(currentDateFromParent));
    }
  },[currentDateFromParent]);

  // Close when clicking outside input & popup
  const handleOutsideClick = useCallback(
    (event) => {
      if (!isOpen) return;
      const p = popupRef.current;
      const inp = inputRef.current;
      if (
        p &&
        !p.contains(event.target) &&
        inp &&
        !inp.contains(event.target)
      ) {
       // console.log("outside click");
        setIsOpen(false);
      }
    },
    [isOpen]
  );

  useEffect(() => {
    document.addEventListener("click", handleOutsideClick);
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [handleOutsideClick]);


  useEffect(() => { setIsOpen(openOnClose);},[openOnClose]);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") setIsOpen(false);
    };
    if (isOpen) document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [isOpen]);

  useEffect(() => {
    if (config) {
      if (
        config.calendar.calendarStartDate &&
        config.calendar.calendarStartDate != ""
      )
        setCalendarStartDate(config.calendar.calendarStartDate);
      if (config.calendar.calendarEndDate)
        setCalendarEndDate(config.calendar.calendarEndDate);

      

      // console.log('applying css variables');
      //console.log(JSON.stringify(config));
      document.documentElement.style.setProperty(
        "--sundays-bg-color",
        config.calendar.weekends.sundaysColor
      );
      document.documentElement.style.setProperty(
        "--sundays-text-color",
        config.calendar.weekends.sundayTextColor
      );
      document.documentElement.style.setProperty(
        "--saturdays-bg-color",
        config.calendar.weekends.saturdaysColor
      );
      document.documentElement.style.setProperty(
        "--saturdays-text-color",
        config.calendar.weekends.saturdayTextColor
      );
    }
  }, [config]);

  const selectDate = (date) => {
    setSelectedDate(date);
    onDateSelect(formatDate(date));
    setIsOpen(false);
  };

  const changeMonth = (offset) => {
    setCurrentDate(
      (prev) => new Date(prev.getFullYear(), prev.getMonth() + offset, 1)
    );
   // console.log("change month called");
  };

  useLayoutEffect(() => {
    if (!isOpen) return;

    const positionPopup = () => {
      if(window.innerWidth < 600){
          //  console.log("mobile");
           // console.log(config.calendar.monthView);

            if(config.calendar.monthView === "double"){

              setPopupPos({
                  top: 0,
                  left: 0,
                  right:0,
                  maxHeight: "100%",
                  visibility: "visible", 
                  placement: "top",
                  maxWidth: "100%",
             
              })

            }else{
             // console.log("single i feel");
              setPopupPos({
                  top: 40 + '%' ,
                  left: 0,
                  right:0,                  
                  bottom:0,
                  maxHeight: null,
                  visibility: "visible", 
                  placement: "top",
                  maxWidth: "100%",
             
              })

            }
            

      }else{


        const inp = inputRef.current;
      const popup = popupRef.current;
      if (!inp || !popup) return;

      popup.style.maxHeight = "";
      popup.style.maxWidth = "";

      const rect = inp.getBoundingClientRect();
      let popupWidth = popup.offsetWidth;
      let popupHeight = popup.offsetHeight;

      const vw = window.innerWidth;
      const vh = window.innerHeight;
      const gap = 8;
      const minSpacing = 8;

      let maxWidth = null;
      if (popupWidth + minSpacing * 2 > vw) {
        maxWidth = vw - minSpacing * 2;
        popupWidth = maxWidth;
      }

      const spaceBelow = vh - rect.bottom;
      const spaceAbove = rect.top;

      let placement = "bottom";
      if (spaceBelow < popupHeight && spaceAbove > spaceBelow)
        placement = "top";

      let top;
      let maxHeight = null;

      if (placement === "bottom") {
        if (spaceBelow >= popupHeight + gap) {
          top = rect.bottom + gap;
        } else {
          //maxHeight = Math.max(spaceBelow - gap * 2, 60);
          top = rect.bottom + gap;
        }
      } else {
        if (spaceAbove >= popupHeight + gap) {
          top = rect.top - popupHeight - gap;
        } else {
          maxHeight = Math.max(spaceAbove - gap * 2, 60);
          top = rect.top - gap - maxHeight;
        }
      }

      // ensure top is inside viewport padding
      if (top < minSpacing) top = minSpacing;
      if (top + (maxHeight || popupHeight) > vh - minSpacing) {
        // adjust if it still overflows
        if (maxHeight) {
          // shrink maxHeight
          maxHeight = Math.max(vh - minSpacing - top, 60);
        } else {
          top = Math.max(minSpacing, vh - minSpacing - popupHeight);
        }
      }

      // align to left of input by default, but clamp horizontally
      let left = rect.left;
      if (left + popupWidth + minSpacing > vw)
        left = Math.max(minSpacing, vw - popupWidth - minSpacing);
      if (left < minSpacing) left = minSpacing;

      setPopupPos({
        top: Math.round(top),
        left: Math.round(left),
        maxHeight: maxHeight ? Math.round(maxHeight) : null,
        visibility: "visible",
        placement,
        maxWidth,
      });

      }
    };

    // position immediately
    positionPopup();

    // reposition while scrolling/resizing
    const onScrollResize = () => positionPopup();
    window.addEventListener("resize", onScrollResize);
    window.addEventListener("scroll", onScrollResize, true);

    return () => {
      window.removeEventListener("resize", onScrollResize);
      window.removeEventListener("scroll", onScrollResize, true);
    };
  }, [isOpen, currentDate, selectedDate, config]);

  
  const renderDays = (year, month) => {
    const firstDay = new Date(year, month, 1).getDay();
    const numDays = new Date(year, month + 1, 0).getDate();
    const today = new Date();
    const days = [];

    const lastDay = new Date(year, month, numDays).getDay();
    const nextDays = 7 - lastDay - 1;

    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`empty-${i}`} className="other-month" />);
    }

    for (let day = 1; day <= numDays; day++) {
      const date = new Date(year, month, day);
      const formatted = formatDate(date);
      const isToday = date.toDateString() === today.toDateString();
      const isSelected =
        selectedDate && date.toDateString() === selectedDate.toDateString();
      const note = config.calendar.dayNotes.find(
        (n) => n.noteDate === formatted
      );
      const holiday = config.calendar.holidays.find(
        (h) => h.holidayDate === formatted
      );
      const hasBgImage = config.calendar.dayBgImages.find(
        (im) => im.date === formatted
      );
      const tooltip = config.calendar.tooltips.find(
        (t) => t.date === formatted
      );
      const disabledDate = config.calendar.disabledDatesList.find(
        (d) => d.date === formatted
      );

      const hasImage = config.calendar.dayImages.find(
        (im) => im.date === formatted
      );



      const isMinDateDisabled = minDate ? date < parseDate(minDate) : false;

      const style = {
        ...config.calendar.cellCustomCss,

        ...(isToday && { backgroundColor: config.popup.currentDateBgColor }),
        ...(isToday && { color: config.popup.currentDateTextColor }),
        ...(isToday && { borderRadius: config.popup.currentDateRadius }),
        ...(isToday && { margin: config.popup.currentDateMargin }),
        ...(isToday && { padding: config.popup.currentDatePadding }),
        ...(isToday && { border: config.popup.currentDateBorder }),

        ...(isSelected && { backgroundColor: config.popup.selectDateBgColor }),
        ...(isSelected && { color: config.popup.selectDateTextColor }),
        ...(isSelected && { borderRadius: config.popup.selectDateRadius }),
        ...(isSelected && { margin: config.popup.selectDateMargin }),
        ...(isSelected && { padding: config.popup.selectDatePadding }),
        ...(isSelected && { border: config.popup.selectDateBorder }),

        ...(holiday?.holidayBgColor && {
          backgroundColor: holiday.holidayBgColor,
        }),
        ...(holiday?.holidayTextColor && { color: holiday.holidayTextColor }),
        ...(holiday?.holidayCellRadius && {
          borderRadius: holiday.holidayCellRadius,
        }),
        ...(holiday?.holidayPadding && { margin: holiday.holidayPadding }),
        ...(hasBgImage?.bgImage && {
          backgroundImage: `linear-gradient(to left, rgba(0,0,0,0.8), rgba(0,0,0,0.2)),   url(${hasBgImage.bgImage})`,
        }),
        ...(hasBgImage?.bgImage && { backgroundRepeat: "no-repeat" }),
        ...(hasBgImage?.bgImage && {
          backgroundSize: config.calendar.dayBgStyles.backgroundSize,
        }),
        ...(hasBgImage?.bgImage && {
          backgroundPosition: config.calendar.dayBgStyles.backgroundPosition,
        }),
        ...(hasBgImage?.bgImage && {
          borderRadius: config.calendar.dayBgStyles.borderRadius,
        }),
        ...(hasBgImage?.bgImage && { color: hasBgImage.textColor }),
        ...(hasBgImage?.bgImage && {
          margin: config.calendar.dayBgStyles.margin,
        }),
        ...(hasBgImage?.bgImage && {
          textAlign: config.calendar.dayBgStyles.textAlign,
        }),
        ...(hasBgImage?.bgImage && {
          fontWeight: config.calendar.dayBgStyles.fontWeight,
        }),
        ...(hasBgImage?.bgImage && {
          fontSize: config.calendar.dayBgStyles.fontSize,
        }),
        ...(hasBgImage?.bgImage && {
          padding: config.calendar.dayBgStyles.padding,
        }),



        // ...( date.getDay() === 0 && { backgroundColor: config.calendar.weekends.sundaysColor }),
        // ...( date.getDay() === 6 && { backgroundColor: config.calendar.weekends.saturdaysColor }),
        // ...( date.getDay() === 0 && { color: config.calendar.weekends.sundayTextColor }),
        // ...( date.getDay() === 6 && { color: config.calendar.weekends.saturdayTextColor } )
      };

      const classes = ["day"];
      const dayClass =["note"];
      if (hasBgImage) classes.push("dayBgImage");
      if (isMinDateDisabled) classes.push("disabled-cell");
      

      days.push(
        <div
          key={day}
          className={classes.join(" ")}
          style={style}
          onClick={() => (isMinDateDisabled ? null : selectDate(date))}
          role="button"
          disabled={isMinDateDisabled}
          aria-disabled={isMinDateDisabled}
          tabIndex={0}
          aria-label={`Select ${formatted}`}
          title={ tooltip?.tooltipText ? tooltip.tooltipText : `${formatted}` }
        >

         { hasImage?.image ? (
          <div className="day-image">
            <img src={hasImage.image} alt="day" />
            {note?.noteText && (
              <div className="note" style={ {color:isSelected?'#fff':'inherit'}}>
                
                {config.popup.currencySymbol}
                {note.noteText}
              </div>
            )}
          </div>
         ):(

          <span>
            {day}
            {note?.noteText && (
              <div className="note" style={ {color:isSelected?'#fff':'inherit'}}>
                {config.popup.currencySymbol}
                {note.noteText}
              </div>
            )}
            
          </span>
          
         )

         }

         
          
        </div>
      );
    }

    for(let i=0; i<nextDays; i++){
      days.push(<div key={`empty-next-${i}`} className="other-month" />);
    }

    return days;
  };

  const renderCalendar = (dateObj) => {
    const year = dateObj.getFullYear();
    const month = dateObj.getMonth();

    const hasMonthBg = config.calendar.monthBgImages.find(
      (m) => m.month === month
    );
    // if (hasMonthBg && isOpen && popupRef.current) {
    //   popupRef.current.style.backgroundImage = `linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url(${hasMonthBg.bgImage})`;
    //   popupRef.current.style.backgroundSize = 'cover';
    //   popupRef.current.style.backgroundPosition = 'center';
    // }

    const monthCalendarStyles = {
      ...(hasMonthBg && {
        backgroundImage: `linear-gradient(rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url(${hasMonthBg.bgImage})`,
      }),
      ...(hasMonthBg && { backgroundSize: "cover" }),
      ...(hasMonthBg && { backgroundPosition: "center" }),
    };

    const weekStyle = {
      color: config.calendar.weeks.weekColor,
      backgroundColor: config.calendar.weeks.weelBgColor,
      ...config.calendar.weeks.weekCustomCss,
    };

    return (
      <div className="calendar-month" style={monthCalendarStyles}>
        {/* <div className="calendar-header">
          <span>{months[month]} {year}</span>
        </div> */}
        <div className="calendar-month-content">

        <div className="calendar-weekdays">
          {weekdays.map((day) => (
            <div key={day} style={weekStyle}>
              {day}
            </div>
          ))}
        </div>
        <div className="calendar-days">{renderDays(year, month)}</div>

        </div>
        {config.popup.popupHasFooterText && (
          <div className="calendar-footer">
            {config.popup.popupFooterText
              .filter((f) => f.month === month)
              .map((f, i) => (
                <div key={i}>{f.footerText}</div>
              ))}
          </div>
        )}
      </div>
    );
  };

  const selectToday = (today) => {
    renderCalendar(today);
    // setSelectedDate(today);
    // onDateSelect(formatDate(today));
    // setIsOpen(false);
  };
  const selectTomorrow = (today) => {
    const tomorrow = new Date(today);
    tomorrow.setDate(tomorrow.getDate() + 1);
    setSelectedDate(tomorrow);
    onDateSelect(formatDate(tomorrow));
    setIsOpen(false);
  };

  const check = () =>{
    
   // console.log(formatDate(currentDate));
   // console.log(currentDate);
   // console.log(calendarStartDate);
   // console.log(parseDate(calendarStartDate));
    
   // console.log(currentDate.getTime() < parseDate(calendarStartDate).getTime());  
   // console.log(currentDate.getTime());
   // console.log(parseDate(calendarStartDate).getTime());
   // console.log((new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)).getTime()  < parseDate(calendarStartDate).getTime());

   // console.log( (new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)).getTime() );
   // console.log( parseDate(calendarStartDate).getTime() );

  }
  // ---------------- render ----------------
  return (
    <div className="vdatepicker">
      {/* <input
        ref={inputRef}
        type="text"
        value={selectedDate ? formatDate(selectedDate) : ''}
        readOnly
        onClick={() => setIsOpen(prev => !prev)}
        aria-label="Open calendar"
      /> */}

      {isOpen && (
        <div
          ref={popupRef}
          className={`calendar-popup`}
          style={{
            position: "fixed",
            // top: popupPos.top + "px",
            // left: popupPos.left + "px",
            zIndex: 10000,
            top: popupPos.top,
            left: popupPos.left,
            right: popupPos.right,
            bottom: popupPos.bottom,

            // sizing / scrolling behaviour
            // maxHeight: popupPos.maxHeight ? `${popupPos.maxHeight}px` : undefined,
            // overflowY: popupPos.maxHeight ? 'hidden' : undefined,
            // maxWidth: popupPos.maxWidth ? `${popupPos.maxWidth}px` : undefined,

            // hide until positioned to avoid flicker
            visibility: popupPos.visibility,

            backgroundColor: config.popup.popupBgColor,
            backgroundImage: config.popup.popupHasBgImage
              ? `url(${config.popup.popupBgImage})`
              : "none",
            backgroundRepeat: "no-repeat",
            backgroundSize: "cover",
            border: config.popup.popupBorder,
            boxShadow: config.popup.popupBoxShadow,

            ...config.popup.popupCustomCss,
          }}
          onClick={(e) => e.stopPropagation()}
        >
          <div className="calendar-title">
            <div className="title-text" onClick={() => {console.log('clicked');setIsOpen(false);}}>
              {/* <span> &#10229; </span> */}
              <span>{config.popup.dateTitle}</span>
            </div>

            <span className="quick-select">
               <div onClick={() => setIsOpen(false)} style={{background:'red',color:'white',padding:"4px 8px"}}> &times;</div>
              {/* <div onClick={() => selectToday(today)}> Today </div>
              <div onClick={() => selectTomorrow(today)}> Tomorrow </div> */}
            </span>
          </div>
          <div className="calendar-nav">
            {/* <button onClick={() => check()}>check</button> */}
            {((new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)).getTime() ) <=
            parseDate(calendarStartDate).getTime() ? (
              <button onClick={() => {}} hidden></button>
            ) : config.icons.leftArrow ? (
              <button
                onClick={() => changeMonth(-1)}
                aria-label="Previous month"
                style={config.icons.iconContainerCss}
              >
                <img src={config.icons.leftArrow} alt="Prev" style={{maxHeight: "30px"}} />
              </button>
            ) : (
              <button
                onClick={() => changeMonth(-1)}
                aria-label="Previous month"
                style={{ width: "20px", height: "20px", margin: "0 5px" }}
              >
                {"<"}
              </button>
            )}
            {config.calendar.monthView === "double" ? (
              <span>
                {months[currentDate.getMonth()]} -{" "}
                {months[currentDate.getMonth() + 1]} {currentDate.getFullYear()}
              </span>
            ) : (
              <span>
                {months[currentDate.getMonth()]} {currentDate.getFullYear()}{" "}
              </span>
            )}

            {

              ((new Date(currentDate.getFullYear(), currentDate.getMonth(), 1)).getTime() ) >=
            parseDate(calendarEndDate).getTime()?(<div></div>):(
              (
                  config.icons.rightArrow ? (
              <button
                onClick={() => changeMonth(1)}
                aria-label="Next month"
                style={config.icons.iconContainerCss}
              >
                {" "}
                <img src={config.icons.rightArrow} alt="Next" style={{maxHeight: "30px"}} />{" "}
              </button>
            ) : (
              <button
                onClick={() => changeMonth(1)}
                aria-label="Next month"
                style={{ width: "20px", height: "20px", margin: "0 5px" }}
              >
                
                {">"}
              </button>
            )
              )
            )


              
              
              
            }
          </div>

          <div className="calendar-days-wrapper">
            {renderCalendar(currentDate)}
            {config.calendar.monthView === "double" &&
              renderCalendar(
                new Date(
                  currentDate.getFullYear(),
                  currentDate.getMonth() + 1,
                  1
                )
              )}
          </div>
        </div>
      )}
    </div>
  );
};

export default VDatePicker4b;
